import { Card, CardBody, Divider } from '@chakra-ui/react';

import { withConfirm, Section, ItemAmount, Total, SubHeading } from 'shared-components';

import { formatCurrency } from '../../../utilities/formatting';
import { FundingSummary } from '../../../types';
import { dependantChildrenLabel } from '../../../utilities/sponsors';

interface IProps {
  fundingSummary: FundingSummary;
}

function formatAmount(amount: number) {
  return `£${formatCurrency(amount)}`;
}

function FundingTable(props: IProps) {
  const { courseFees, studentLivingCost, spouseLivingCost, childrenLivingCost, totalToBeShown } = props.fundingSummary;

  function renderCourseFee() {
    if (courseFees.length === 0) return null;

    return (
      <Section data-selector="funding-course-fee" title="Course Fee">
        {courseFees.map((fund, i) => (
          <ItemAmount key={i} label={fund.label} amount={formatAmount(fund.amount)} />
        ))}
      </Section>
    );
  }

  function renderStudentLivingCost() {
    if (studentLivingCost.amount === 0) return null;

    return (
      <Section data-selector="funding-student-living-cost" title="Your Living Cost">
        <ItemAmount label={studentLivingCost.label} amount={formatAmount(studentLivingCost.amount)} />
      </Section>
    );
  }

  function renderDependantLivingCost() {
    if (spouseLivingCost.amount === 0 && childrenLivingCost.amount === 0) return null;

    return (
      <Section data-selector="funding-dependant-living-cost" title="Dependant's Living Cost">
        {spouseLivingCost.amount !== 0 && <ItemAmount label="Partner" amount={formatAmount(spouseLivingCost.amount)} />}

        {childrenLivingCost.amount !== 0 && (
          <ItemAmount
            label={dependantChildrenLabel(childrenLivingCost.number)}
            amount={formatAmount(childrenLivingCost.amount)}
          />
        )}
      </Section>
    );
  }

  function renderTotal() {
    return <Total label="Total funding to be shown" amount={formatAmount(totalToBeShown)} />;
  }

  return (
    <>
      <SubHeading>What you need to prove you have available:</SubHeading>

      <Card data-selector="funding-table" variant="filled" borderRadius="lg">
        <CardBody>
          {renderCourseFee()}
          {renderStudentLivingCost()}
          {renderDependantLivingCost()}
          <Divider mt={6} mb={6} />
          {renderTotal()}
        </CardBody>
      </Card>
    </>
  );
}

export default withConfirm(FundingTable);
